import { createAction, props } from "@ngrx/store";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { Scenario } from "src/components/shared-components/class/general-classes/scenario";
import { ScenariosStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Scenarios unset state and update storage key
 */
export const scenariosUnsetKeyStorageAction = createAction(
    ScenariosStoreAction.SCENARIOS_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const scenariosLoadInitStartAction = createAction(
    ScenariosStoreAction.SCENARIOS_LOAD_INIT_START
);

/**
 * Action to load full list of scenarios
 */
export const scenariosLoadListFromApiAction = createAction(
    ScenariosStoreAction.SCENARIOS_LOAD_FROM_API
);

/**
 * Action to load last modified list of scenarios
 */
export const scenariosLoadLastModifiedFromApiAction = createAction(
    ScenariosStoreAction.SCENARIOS_LOAD_LAST_MODIFIED_FROM_API,
    props<{ scenarioObject: GenericApiData }>()
);

/**
 * Action scenarios load success
 */
export const scenariosLoadSuccessAction = createAction(
    ScenariosStoreAction.SCENARIOS_LOAD_SUCCESS,
    props<{ scenarioObject: GenericApiData }>()
);

/**
 * Action scenarios load error. The HTTP status code is forwarded so that
 * components can react on the specific error code.
 */
export const scenariosLoadErrorAction = createAction(
    ScenariosStoreAction.SCENARIOS_LOAD_ERROR,
    props<{ errorCode: number }>()
);

/**
 * Insert of a scenario notified by the broker
 */
export const scenarioInsertReceivedAction = createAction(
    ScenariosStoreAction.SCENARIO_INSERT_RECEIVED,
    props<{ idScenario: number; clientID: string }>()
);

/**
 * Update of a scenario notified by the broker
 */
export const scenarioUpdateReceivedAction = createAction(
    ScenariosStoreAction.SCENARIO_UPDATE_RECEIVED,
    props<{ idScenario: number; clientID: string }>()
);

/**
 * Delete of a scenario notified by the broker
 */
export const scenarioDeleteReceivedAction = createAction(
    ScenariosStoreAction.SCENARIO_DELETE_RECEIVED,
    props<{ idScenario: number; clientID: string }>()
);

/**
 * A scenario has been inserted in the store
 */
export const scenarioInsertedAction = createAction(
    ScenariosStoreAction.SCENARIO_INSERTED,
    props<{ scenario: Scenario; clientID: string }>()
);

/**
 * A scenario has been updated in the store
 */
export const scenarioUpdatedAction = createAction(
    ScenariosStoreAction.SCENARIO_UPDATED,
    props<{ scenario: Scenario; clientID: string }>()
);

/**
 * A scenario has been removed from the store
 */
export const scenarioDeletedAction = createAction(
    ScenariosStoreAction.SCENARIO_DELETED,
    props<{ idScenario: number; clientID: string }>()
);

/**
 * A schedule has been linked to a scenario
 */
export const scenarioScheduleAssignedAction = createAction(
    ScenariosStoreAction.SCENARIO_SCHEDULE_ASSIGNED,
    props<{ idScenario: number; idBigLogic: number; clientID: string }>()
);

/**
 * A schedule has been unlinked from a scenario
 */
export const scenarioScheduleUnassignedAction = createAction(
    ScenariosStoreAction.SCENARIO_SCHEDULE_UNASSIGNED,
    props<{ idScenario: number; idBigLogic: number; clientID: string }>()
);

/**
 * A schedule has been deleted; remove it from scheduleIDs of every scenario
 */
export const scheduleDeletedFromScenariosAction = createAction(
    ScenariosStoreAction.SCENARIO_SCHEDULE_DELETED,
    props<{ idBigLogic: number }>()
);

/**
 * The running flag of a scenario changed (notified via MQTT)
 */
export const scenarioRunningChangedAction = createAction(
    ScenariosStoreAction.SCENARIO_RUNNING_CHANGED,
    props<{ idScenario: number; running: boolean }>()
);
